import BS_OBJECT_TYPES from '../api/brightspot/objectTypeIds'
import { RTCInitialState } from '../state/RTCReducer'

export default function getIsLive({ objectTypeId, date, duration = null }) {
  const durationMs = duration ? duration * 60000 : 0
  const nowMs = Date.now() + RTCInitialState.timeOffset

  const isLive = objectTypeId === BS_OBJECT_TYPES.LIVE_SESSION && nowMs < date?.timestamp + durationMs
  return isLive
}
